var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMagic = function SvgIconMagic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 6a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
  })));
};
export { SvgIconMagic as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjUgNkMxMy41IDkuMDM3NTcgMTEuMDM3NiAxMS41IDggMTEuNUM0Ljk2MjQzIDExLjUgMi41IDkuMDM3NTcgMi41IDZDMi41IDIuOTYyNDMgNC45NjI0MyAwLjUgOCAwLjVDMTEuMDM3NiAwLjUgMTMuNSAyLjk2MjQzIDEzLjUgNloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjUgMTBDMTMuNSAxMy4wMzc2IDExLjAzNzYgMTUuNSA4IDE1LjVDNC45NjI0MyAxNS41IDIuNSAxMy4wMzc2IDIuNSAxMEMyLjUgNi45NjI0MyA0Ljk2MjQzIDQuNSA4IDQuNUMxMS4wMzc2IDQuNSAxMy41IDYuOTYyNDMgMTMuNSAxMFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";